import { api } from '@/core/api/';
import dsApi from '@/core/digital_signature_api/';

const URL = 'api/signaturescontractor';

const signatureURL = 'api/external';

export const getSignatures = (id) => api.get(`${URL}/getSignatures/${id}`);

export const deleteSignatureHandwritten = (id) =>
  api.post(`${URL}/deleteSignatureHandwritten/${id}`);

export const login = async (payload) =>
  await dsApi.post(`${signatureURL}/login`, payload);

export const cancelSignature = async (
  documentId,
  cancellationReason,
  isForRenderedIneffective = false
) =>
  await dsApi.post(`${signatureURL}/documents/${documentId}/cancel`, {
    cancellationReason,
    isForRenderedIneffective,
  });

export const getStatusSignature = (documentId) =>
  dsApi.get(`${signatureURL}/documents/${documentId}/status`);

export const getDocumentInfo = (documentId) =>
  dsApi.get(`${signatureURL}/documents/${documentId}/info`);

export const createDocumentForSignature = async (payload) =>
  await dsApi.post(`${signatureURL}/documents/configured`, payload);

export const resendInvitationSigning = async (payload) =>
  await dsApi.post(`${signatureURL}/documents/resendinvitation`, payload);

export const sendInvitationSigning = async (payload, documentId) =>
  await dsApi.post(
    `${signatureURL}/documents/invitationtosign/${documentId}`,
    payload
  );
